import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Celebrity() {
  return <section className="py-24 bg-brand-dark text-white relative overflow-hidden" data-id="element-102">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#D4AF37 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-103"></div>

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-104">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-105">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="flex justify-center gap-2 mb-6 text-brand-gold" data-id="element-106">
            {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 fill-current" data-id="element-107" />)}
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-serif mb-6" data-id="element-108">
            Trusted by the Stars
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-brand-light/80 text-lg font-light" data-id="element-109">
            From Hollywood elites to fashion icons, Shazz's chair is the
            destination for those who demand perfection. Experience the same
            luxury treatment trusted by celebrities like Paris Hilton.
          </motion.p>
        </div>

        <div className="max-w-5xl mx-auto" data-id="element-110">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative aspect-video md:aspect-[21/9] overflow-hidden group" data-id="element-111">
            <img src="https://cdn.magicpatterns.com/uploads/u73pX5itgvBtVZ2L7qjdCm/Screenshot_2026-06-08_at_12.22.17_PM.png" alt="Shazz with Paris Hilton" className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105" data-id="element-112" />
            <div className="absolute inset-0 bg-gradient-to-t from-brand-dark via-brand-dark/20 to-transparent opacity-80" data-id="element-113" />

            <div className="absolute bottom-0 left-0 right-0 p-8 md:p-12 text-center md:text-left" data-id="element-114">
              <p className="text-brand-gold font-serif text-2xl md:text-3xl italic mb-2" data-id="element-115">
                "That's hot."
              </p>
              <p className="text-white/90 uppercase tracking-widest text-sm font-semibold" data-id="element-116">
                Styling Paris Hilton
              </p>
            </div>
          </motion.div>

          {/* Paris Hilton look gallery */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8" data-id="element-117">
            {parisLooks.map((look, index) => <motion.figure key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="relative aspect-square overflow-hidden group ring-1 ring-brand-gold/20" data-id="element-118">
                <img src={look.src} alt={look.alt} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-119" />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-dark/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-120" />
                <figcaption className="absolute bottom-0 left-0 right-0 p-3 text-white text-xs font-semibold uppercase tracking-wider translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300" data-id="element-121">
                  {look.caption}
                </figcaption>
              </motion.figure>)}
          </div>
        </div>
      </div>
    </section>;
}
const parisLooks = [{
  src: 'https://cdn.magicpatterns.com/uploads/sZkqQFxtcFQRNWLD1JYb4Q/Screenshot_2026-06-08_at_12.26.30_PM.png',
  alt: 'Paris Hilton with braided side-swept waves styled by Shazz',
  caption: 'Braided Glam Waves'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/kWtLzWuTxoDbtqt59VYPck/Screenshot_2026-06-08_at_12.26.47_PM.png',
  alt: 'Shazz and Paris Hilton together behind the scenes',
  caption: 'Behind the Scenes'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/h3sLP7N5fzkJRqDAqCs7cX/Screenshot_2026-06-08_at_12.26.52_PM.png',
  alt: 'Paris Hilton braided ponytail profile styled by Shazz',
  caption: 'Side-Swept Elegance'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/r8UsMhnAtC6jYPm44wPT5h/Screenshot_2026-06-08_at_12.26.54_PM.png',
  alt: 'Paris Hilton soft curled braid styled by Shazz',
  caption: 'Soft Curled Braid'
}];